const pixelStringRe = /(\d+)px/;
export function pixelStringToNumber(str) {
  if (typeof str !== 'string') {
    return str;
  }
  const match = str.match(pixelStringRe);
  let parsed;
  if (match) {
    parsed = parseInt(match[1], 10);
  } else {
    parsed = parseInt(str, 10);
  }
  return isNaN(parsed) ? undefined : parsed;
}
const percentageStringRe = /^(\d*(\.?\d+))%$/;
export function percentageStringToNumber(str) {
  if (typeof str !== 'string') {
    return str;
  }
  const match = str.match(percentageStringRe);
  let parsed;
  if (match) {
    parsed = parseInt(match[1], 10);
  } else {
    parsed = parseInt(str, 10);
  }
  return isNaN(parsed) ? undefined : parsed;
}
export function isPercentage(value) {
  return typeof value === 'string' && value.length > 1 && value[value.length - 1] === '%';
}